<template>
  <PortalWidget :widget="widgetTitle">
    <div
      v-if="!isLoading" 
      class="form-horizontal"
    >
      <div class="form-group">
        <label class="col-sm-3 control-label">
          {{ $t("ACCOUNT_BILLING_BALANCE_CURRENT") }}
          <i
            v-tooltip.right="$t('ACCOUNT_BILLING_BALANCE_CURRENT_TT')"
            class="fa fa-question-circle m-l-5"
          />
        </label>

        <div class="col-sm-1 p-t-7">
          ${{ billingPlan.accountBalance }}
        </div>
      </div>

      <div class="form-group">
        <div class="col-sm-9 col-sm-offset-3">
          <button
            type="button"
            class="btn btn-lg btn-primary"
            @click="addBalance()"
          >
            {{ $t("ACCOUNT_BILLING_BALANCE_ADD_BUTTON") }}
          </button>
        </div>
      </div>
    </div>
    <div v-else>
      <Loader />
      <span v-t="'LOADING'" />
    </div>
    <AddFundsModal
      v-if="showAddFunds"
      @closeModal="closeModal"
    />
  </PortalWidget>
</template>

<script>

import messages from '../../locales';
import sharedMessages from '@/core/locales';
import { mapState } from 'vuex';
import AddFundsModal from './AddFundsModal';


export default {
  name: 'AccountBalance',
  components: {
    AddFundsModal
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      widgetTitle: {
        title: this.$t('ACCOUNT_BALANCE'),
        iconClass: 'fa fa-money'
      },
      showAddFunds: false,
    };
  },

  computed: {
    ...mapState('billingSettingsStore', ['billingPlan']),
  },

  methods: {
    addBalance() {
      this.showAddFunds = true;
    },
    closeModal() {
      this.showAddFunds = false;
    },
  },

  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style>

</style>